export const SET_CURRENT_CITY = 'app/setCurrentCity'
export const SET_USER_CITY = 'app/setCurrentCity'
export const RESET_CURRENT_CITY = 'app/resetCurrentCity'
export const SET_SCROLL_LOCK = 'app/setScrollLock'
export const SET_SHOW_EMAIL_CONFIRM_MODAL = 'app/setShowEmailConfirmModal'
